export const environment = {
  production: true,
  apiBaseUrl: 'https://makeclub-api.azurewebsites.net',
  storageBaseUrl: 'https://makeclubstorage.blob.core.windows.net/makeclub-blob/profiles',
  auth: {
    domain: 'auth.makeclub.app',
    clientId: '06GnNSv3rLNSLqL9R0EWQi35o8iz5RQ1',
    audience: 'https://dev-api.makeclub.app',
  },
};
